/** "Which airlines let you hold a fare? (2026 fare hold guide)": metadata (the article is in ../bodies/airline-fare-hold-policies.js). */
export default {
  slug: 'airline-fare-hold-policies',
  category: 'Booking tips',
  title: 'Which airlines let you hold a fare? (2026 fare hold guide)',
  seoTitle: 'Which Airlines Let You Hold a Fare? (2026 Guide)',
  description: 'Which airlines let you hold a fare in 2026: American, United FareLock, Emirates, Qatar, Turkish, BA and more, plus the US 24-hour rule and price freezes.',
  dek: 'A few airlines will hold a price for free for a day. More will hold it for a fee, for a day to about two weeks. Here is who does what, what the US 24-hour rule really requires, and what to do when you need longer.',
  author: 'Stephanie Ludwig',
  published: '2026-11-03',
  updated: '2026-11-03',
  faqs: [
    {
      q: 'Which airlines let you hold a fare for free?',
      a: 'As of November 2026, American Airlines offers a free 24-hour hold on select flights booked at least 7 days before departure, and Emirates\' US site offers a free 24-hour hold on Economy fares. Most other airline holds charge a fee.',
    },
    {
      q: 'Does the 24-hour rule mean every airline must hold my fare?',
      a: 'No. US rules let each airline choose between holding a reservation without payment for 24 hours or letting you cancel without penalty within 24 hours, and only when you book a week or more before departure. Most US airlines offer the cancellation option instead of a hold.',
    },
    {
      q: 'How long can you hold a flight price?',
      a: 'Airline holds range from 24 hours to about two weeks: Lufthansa offers 48 hours, Qatar Airways and British Airways up to 72 hours, United FareLock and Copa PriceLock up to 7 days, and Turkish Airlines up to 15 days. For longer, a deposit-based payment plan is the main option.',
    },
    {
      q: 'Is a fare hold fee refundable?',
      a: 'Usually not. British Airways refunds its deposit and Turkish Airlines refunds its hold fee when you complete the purchase in time, but Copa, KLM, Air France, Qatar Airways and Lufthansa keep the fee.',
    },
    {
      q: 'Does Hopper still offer Price Freeze?',
      a: 'Yes. Price Freeze was still part of Hopper\'s app when the FTC announced its July 2026 settlement with Hopper, which alleged the app didn\'t clearly disclose that the freeze only covers increases up to a certain amount. Check the fee, the cap and the expiry before you pay.',
    },
    {
      q: 'How does Defera secure a flight price?',
      a: 'You pay a deposit, as low as 5% on trips 90 or more days away, and the rest in automatic weekly or bi-weekly payments. Once your booking is approved, your agreed-upon trip price is protected from future fare increases while you stay in good standing on your plan.',
    },
  ],
  related: [
    'lock-flight-price-with-deposit',
    'when-to-book-flights-fare-data',
    'flight-layaway-vs-bnpl',
  ],
};
